import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";

import { LoadingAnimation } from "../../../../components/Loading/LoadingAnimation";
import { UniqueVisitorsWhoBoughtGraph } from "../../../../components/Graphs/graphs";
import { SelectUniqueBoughtStatus, SelectWeeks, SelectBoughtVisitors, SelectBoughtPercentVisitors, graphUniqueBought, setUniqueBought} from "./uniqueBoughtSlice";
import { SingleGraphLoading } from "../../../../components/Skeletons";



const UniqueBought = () => {
  const dispatch = useDispatch();
  const sessionUser = useSelector(selectLogInUsername)
  const user = sessionUser?.split('@')[0];
  
  const UniqueBookingsData = useSelector(state => state.uniqueBookings)
  const UniqueBoughtData = useSelector(state => state.uniqueBought)
  const loading = useSelector(SelectUniqueBoughtStatus);
  const weeks = useSelector(SelectWeeks)
  const visitors = useSelector(SelectBoughtVisitors)
  const percentOfVisitors = useSelector(SelectBoughtPercentVisitors)
  const graphLabel = UniqueBoughtData['data']?.[2]?.['label']


  useEffect(() => {
    if (!user) return null
    if(weeks.length===0) dispatch(graphUniqueBought(user))
  }, [user, weeks])

  useEffect(() => {
    if (UniqueBookingsData.weeks?.length === 0) return
    if (UniqueBoughtData?.weeks.length === 0) dispatch(setUniqueBought(UniqueBookingsData?.data))
  },[UniqueBookingsData])



  if (loading === 'loading') return <SingleGraphLoading/>
  
  return (
    <UniqueVisitorsWhoBoughtGraph
      weeks={weeks}
      visitors={visitors}
      percentOfVisitors={percentOfVisitors}
      graphLabel={graphLabel}
    />
  )
}

export default UniqueBought;
